$( ->
  enable_sortable = ->
    $('.sort-owner').each ->
      items = "div"
      if $(this).data('child-class')?
        items = "div." + $(this).data('child-class')
      opts =
        containerSelector: 'div.sort-owner'
        itemSelector: items
        containerPath: '> ' + items
        handle: '.handle'
        placeholder: '<div class="placeholder"><i class="fa fa-caret-right"></i></div>'
        onMousedown: ($item, _super, event)->
          $('.drag-active').removeClass('drag-active')
          $(event.currentTarget).closest('.nested-fields').addClass('drag-active')
          _super($item, _super, event)
        onDrop: (item, targetContainer, _super)->
          _super(item, targetContainer, _super)
          $('.drag-active').removeClass('drag-active')
          pos = 0
          $(targetContainer.el).closestDown('input[data-field="position"]').each ->
            pos = pos + 1
            $(this).val(pos)
      if $(this).data('sortable-options')?
        opts = $.extend(opts, $(this).data('sortable-options'))

      $(this).sortable(opts)

  enable_sortable()
  $(document).on 'show.bs.modal', '.modal', enable_sortable

  $('.sort-owner').closest('form').bind 'submit', (ev)->
    pos = 0
    $(this).closestDown('input[data-field="position"]').each ->
      pos = pos + 1
      $(this).val(pos)

  $(document).on 'click', '.sort-owner a.move_up', (ev)->
    ev.preventDefault()
    a = $(this).closest('.row')
    b = a.prev('.row')
    if b.length > 0
      b.before(a)
    false

  $(document).on 'click', '.sort-owner a.move_down', (ev)->
    ev.preventDefault()
    a = $(this).closest('.row')
    b = a.next('.row')
    if b.length > 0
      b.after(a)
    false

  $('.index-sort-owner').each ->
    index = $(this)
    index.data 'update-func', ->
      serialized_items = []
      index.find('.' + index.data('child-class')).each ->
        name_parts = $(this).attr('id').split('_')
        id = name_parts.pop()
        name = name_parts.join('_')
        serialized_items.push(name + '[]=' + id)

      $.post(index.data('update-url'), serialized_items.join('&'))

    opts =
      handle: '.handle'
      placeholder: '<div class="placeholder"><i class="fa fa-caret-right"></i></div>'
      onDrop: (item, targetContainer, _super)->
        _super(item, targetContainer, _super)
        index.data('update-func')()

    if index.data('sortable-options')?
      opts = $.extend(opts, index.data('sortable-options'))

    index.sortable(opts)
    index.closest('form').on 'submit', index.data('update-func')
)
